module.exports = __webpack_public_path__ + "static/img/2.f450e90.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/3/1/sp/2.png
// module id = WW46
// module chunks = 0